import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams} from 'ionic-angular';
import { QRScanner, QRScannerStatus } from '@ionic-native/qr-scanner';

import { LoginProvider } from '../../providers/login';
/**
 * Generated class for the QrscannerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-qrscanner',
  templateUrl: 'qrscanner.html',
})
export class QrscannerPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, private qrScanner: QRScanner,public loginProvider: LoginProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad QrscannerPage');
  }

  ionViewDidEnter(){
    this.qrScanner.prepare()
        .then((status: QRScannerStatus) => {
            if (status.authorized) {
                // camera permission was granted

                this.qrScanner.show();
                document.body.style.visibility = 'hidden'
                setTimeout(() => { document.body.style.visibility = 'visible' }, 1)
                window.document.querySelector('ion-app').classList.add('cameraView');

                let scanSub = this.qrScanner.scan().subscribe((text: string) => {



                    window.document.querySelector('ion-app').classList.remove('cameraView');
                    this.qrScanner.hide(); // hide camera preview
                    scanSub.unsubscribe(); // stop scanning
                    this.loginProvider.checkQrCode(text);
                });


            } else if (status.denied) {
                this.navCtrl.pop();
            } else {
                this.navCtrl.pop();
            }
        })
        .catch((e: any) => console.log('Error is', e));
  }


  ionViewWillLeave(){
    this.qrScanner.destroy();
    window.document.querySelector('ion-app').classList.remove('cameraView');
  }

}



// WEBPACK FOOTER //
// ./src/pages/qrscanner/qrscanner.ts